import React, { Suspense } from "react";
import { Alert, Button, Card, Spin } from "antd";

class AdminPageErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return <Alert
        type="error"
        showIcon
        message="Không thể mở trang quản trị"
        description="Tải lại trang để nhận phiên bản mới nhất."
        action={<Button onClick={() => window.location.reload()}>Tải lại</Button>}
        style={{ margin: 24 }}
      />;
    }
    return this.props.children;
  }
}

function AdminRouteContent({ page: Page }) {
  return <AdminPageErrorBoundary>
    <Suspense fallback={<Card style={{ margin: 24 }}><Spin /> <span style={{ marginLeft: 12 }}>Đang mở trang quản trị...</span></Card>}>
      <Page />
    </Suspense>
  </AdminPageErrorBoundary>;
}

export default AdminRouteContent;
